module.exports = __webpack_public_path__ + "img/errorMsg.cb9e757.png";